import React from "react";
import ReactDOM from "react-dom/client";
import "./polyfills"; // Load polyfills first for older iOS Safari compatibility
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "./context/UserContext";
import { UploadProvider } from "./context/UploadContext";
import GlobalUploadLoader from "./components/Utils/GlobalUploadLoader";
import CookieBanner from "./components/Utils/CookieBanner";
import { Slide } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserProvider>
    <UploadProvider>
      <GlobalUploadLoader />
      <App />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
      <CookieBanner />
    </UploadProvider>
  </UserProvider>,
);
